import { Navigate, Route, Routes } from 'react-router-dom'
import { AppLayout } from './layouts/AppLayout'
import { DashboardPage } from './pages/DashboardPage'
import { SquadPage } from './pages/SquadPage'
import { TacticsPage } from './pages/TacticsPage'
import { MatchesPage } from './pages/MatchesPage'
import { OpponentsPage } from './pages/OpponentsPage'
import { SettingsPage } from './pages/SettingsPage'
import { FirstRun } from './components/FirstRun'

export function App() {
  return <><Routes>
    <Route element={<AppLayout />}>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/matches" element={<MatchesPage />} />
      <Route path="/squad" element={<SquadPage />} />
      <Route path="/tactics" element={<TacticsPage />} />
      <Route path="/opponents" element={<OpponentsPage />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes><FirstRun/></>
}
